<template>
  <HLModal
    :show="show"
    :show-header="true"
    :show-footer="true"
    :show-close="true"
    :mask-closable="true"
    :close-on-esc="true"
    width="450"
    class="delete-modal"
    @update:show="(value) => !value && handleCancel()"
  >
    <template #header>
      <span class="text-lg font-bold text-gray-900 dark:text-white">
        Delete Sanity Request
      </span>
    </template>
    
    <template #default>
      <div class="px-6">
        <div class="flex items-start space-x-3">
          <div class="flex-shrink-0 mt-1">
            <HLIcon size="24" color="#EF4444">
              <AlertTriangleIcon />
            </HLIcon>
          </div>
          <div class="flex-1">
            <HLText size="sm" class="text-gray-700 dark:text-gray-300">
              Are you sure you want to delete <strong class="text-gray-900 dark:text-white">"{{ requestName }}"</strong>?
            </HLText>
            <div class="mt-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3">
              <HLText size="xs" color="muted">
                This action will mark the request as deleted but can be restored later from the database if needed.
              </HLText>
            </div>
          </div>
        </div>
      </div>
    </template>
    
    <template #footer>
      <div class="flex justify-end space-x-2 px-6 pb-6">
        <HLButton
          variant="secondary"
          size="md"
          @click="handleCancel"
          :disabled="deleting"
        >
          Cancel
        </HLButton>
        <HLButton
          variant="primary"
          color="red"
          size="md"
          @click="handleConfirm"
          :loading="deleting"
        >
          Delete
        </HLButton>
      </div>
    </template>
  </HLModal>
</template>

<script setup>
import { ref } from 'vue'
import {
  HLModal,
  HLButton,
  HLText,
  HLIcon
} from '@platform-ui/highrise'
import { AlertTriangleIcon } from '@gohighlevel/ghl-icons/24/outline'

const props = defineProps({
  show: {
    type: Boolean,
    required: true
  },
  requestName: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:show', 'confirm'])

const deleting = ref(false)

const handleConfirm = () => {
  emit('confirm')
}

const handleCancel = () => {
  emit('update:show', false)
}
</script>

